/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MediaLibraryDeleteRequest
 */
export interface MediaLibraryDeleteRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof MediaLibraryDeleteRequest
     */
    bundles?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof MediaLibraryDeleteRequest
     */
    files?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof MediaLibraryDeleteRequest
     */
    assets?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof MediaLibraryDeleteRequest
     */
    deleteFromDatabase?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaLibraryDeleteRequest
     */
    deleteFromStorage?: boolean;
}

export function MediaLibraryDeleteRequestFromJSON(json: any): MediaLibraryDeleteRequest {
    return MediaLibraryDeleteRequestFromJSONTyped(json, false);
}

export function MediaLibraryDeleteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaLibraryDeleteRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'bundles': !exists(json, 'bundles') ? undefined : json['bundles'],
        'files': !exists(json, 'files') ? undefined : json['files'],
        'assets': !exists(json, 'assets') ? undefined : json['assets'],
        'deleteFromDatabase': !exists(json, 'delete_from_database') ? undefined : json['delete_from_database'],
        'deleteFromStorage': !exists(json, 'delete_from_storage') ? undefined : json['delete_from_storage'],
    };
}

export function MediaLibraryDeleteRequestToJSON(value?: MediaLibraryDeleteRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'bundles': value.bundles,
        'files': value.files,
        'assets': value.assets,
        'delete_from_database': value.deleteFromDatabase,
        'delete_from_storage': value.deleteFromStorage,
    };
}


